var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "social-facebook_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M34.207 5c-6.285 0-11.38 5.037-11.38 11.25v10.125H16v11.25h6.828V59h15.93V37.625h6.828v-11.25H38.76v-6.75H49V5z",
    clipRule: "evenodd"
  })));
};
export { SvgSocialFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM0LjIwNjkgNUMyNy45MjIzIDUgMjIuODI3NiAxMC4wMzY4IDIyLjgyNzYgMTYuMjVWMjYuMzc1SDE2VjM3LjYyNUgyMi44Mjc2VjU5SDM4Ljc1ODZWMzcuNjI1SDQ1LjU4NjJWMjYuMzc1SDM4Ljc1ODZWMTkuNjI1SDQ5VjVIMzQuMjA2OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";